module.exports = __webpack_public_path__ + "img/13.17ecfe1d.png";